<hlm-alert-dialog>
  <hlm-alert-dialog-content *brnAlertDialogContent class="p-6 max-w-2xl">
    <div class="flex flex-col gap-4">
      <div class="flex justify-center w-full">
        <ng-icon
          hlm
          name="lucideTriangleAlert"
          size="xl"
          class="text-destructive"
        />
      </div>

      <div class="flex flex-col gap-2 text-center">
        <h3 class="text-lg font-semibold">
          Il modello {{ templateTypeLabel() }} contiene errori
        </h3>
        <p class="text-sm text-muted-foreground">
          Abbiamo trovato {{ errorCountLabel() }} nel file che hai caricato. Il
          modello non è stato salvato. Correggi i segnaposto indicati in Word
          e riprova.
        </p>
      </div>

      <div
        class="flex flex-col gap-2 max-h-96 overflow-y-auto border rounded-md p-3"
      >
        @for (err of errors(); track $index) {
          <div
            class="flex items-start gap-3 p-2 border-b last:border-b-0 border-border"
          >
            <ng-icon
              hlm
              name="lucideCircleAlert"
              size="sm"
              class="text-destructive shrink-0 mt-0.5"
            />
            <div class="flex flex-col gap-0.5 text-left flex-1 min-w-0">
              <p class="text-sm font-medium">
                {{ err.italianMessage }}
                @if (err.tagName) {
                  <code
                    class="ml-1 text-xs bg-muted px-1.5 py-0.5 rounded font-mono"
                    >{{ "{" + err.tagName + "}" }}</code
                  >
                }
              </p>
              @if (err.context) {
                <p
                  class="text-xs text-muted-foreground font-mono truncate"
                  [title]="err.context"
                >
                  {{ err.context }}
                </p>
              }
            </div>
          </div>
        }
      </div>

      <div class="text-sm text-muted-foreground bg-muted/50 p-3 rounded-md">
        <strong class="text-foreground">Suggerimento:</strong> scarica il
        modello esempio e confronta i segnaposto con quelli del tuo file. Il
        modello esempio contiene già tutti i segnaposto supportati nei punti
        giusti.
      </div>

      <div class="flex flex-col sm:flex-row gap-2 sm:justify-end">
        <button
          type="button"
          hlmBtn
          variant="outline"
          (click)="onDownloadExample()"
        >
          Scarica modello esempio
        </button>
        <button type="button" hlmAlertDialogCancel (click)="onClose()">
          Chiudi
        </button>
      </div>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
